import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Button from 'material-ui/Button';
import 'jquery-slimscroll/jquery.slimscroll.min';


class SideNavContent extends Component {
    componentDidMount() {
        const {history} = this.props;
        const $nav = $(this.nav);
        const slideDuration = 250;

        $nav.slimscroll({
            height: '100%'
        });

        const pathname = `#${history.location.pathname}`;// get current path

        $('ul.nav-menu > li.menu').click(function () {
            const menuLi = this;
            $('ul.nav-menu > li.menu').not(menuLi).removeClass('open');
            $('ul.nav-menu > li.menu ul').not($('ul', menuLi)).slideUp(slideDuration);
            $('> ul', menuLi).slideToggle(slideDuration);
            $(menuLi).toggleClass('open');
        });

        $('ul.sub-menu li').click(function (e) {
            let superSubMenu = $(this).parent();
            if (superSubMenu.parent().hasClass('active')) {
                $('li', superSubMenu).not($(this)).removeClass('active');
            }
            else {
                $('ul.sub-menu li').not($(this)).removeClass('active');
            }

            $(this).toggleClass('active');
            e.stopPropagation();
        });

        const activeLi = $('a[href="' + pathname + '"]');// select current a element
        const activeNav = activeLi.closest('ul'); // select closest ul
        if (activeNav.hasClass('sub-menu')) {
            activeNav.slideDown(slideDuration);
            activeNav.parent().addClass('open');
            activeLi.parent().addClass('active');
        } else {
            activeLi.parent().addClass('open');
        }
    }


    render() {
        return (
            <ul className="nav-menu" ref={(c) => {
                this.nav = c;
            }}>

                <li className="nav-header">Main</li>

                <li className="menu">
                    <Button href="javascript:void(0)">
                        <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
                        <span className="nav-text">Dashboard</span>
                    </Button>
                    <ul className="sub-menu">
                        <li>
                            <Button className="prepend-icon" href="#/darsham/dashboard/default">
                                <span className="nav-text">General Settings</span>
                            </Button>
                        </li>
                       
                        <li>
                            <Button className="prepend-icon" href="#/darsham/dashboard/news">
                                <span className="nav-text">Customers</span>
                            </Button>
                        </li>
                        <li>
                            <Button className="prepend-icon" href="#/darsham/dashboard/drivers">
                                <span className="nav-text">Drivers Registration</span>
                            </Button>
                        </li>
                        <li>
                            <Button className="prepend-icon" href="#/darsham/dashboard/driversgraph">
                                <span className="nav-text">Drivers Graph</span>
                            </Button>
                        </li>
                               
                        <li>
                            <Button className="prepend-icon" href="#/darsham/dashboard/driversdetails">
                                <span className="nav-text">Drivers Details</span>
                            </Button>
                        </li>
                    </ul>

                </li>

                <li className="menu">
                    <Button href="javascript:void(0)">
                        <i className="zmdi zmdi-device-hub zmdi-hc-fw"/>
                        <span className="nav-text">Car Settings</span>
                    </Button>

                    <ul className="sub-menu">
                        <li>
                            <Button className="prepend-icon" href="javascript:void(0)">
                                <span className="nav-text">Add/Remove</span>
                            </Button>
                        </li>
                        <li className="menu">
                            <Button className="prepend-icon" href="javascript:void(0)">
                                <span className="nav-text">Car</span>
                            </Button>

                            <ul className="sub-menu">
                                <li>
                                    <Button href="javascript:void(0)">
                                        <span className="nav-text">Pool</span>
                                    </Button>
                                </li>

                                <li>
                                    <Button href="javascript:void(0)">
                                        <span className="nav-text">Micro</span>
                                    </Button>
                                </li>
                                    <li>
                                    <Button href="javascript:void(0)">
                                        <span className="nav-text">Mini</span>
                                    </Button>
                                </li>

                                      <li>
                                    <Button href="javascript:void(0)">
                                        <span className="nav-text">Luxury</span>
                                    </Button>
                                </li>

                                <li>
                                    <Button href="javascript:void(0)">
                                        <span className="nav-text">Freight</span>
                                    </Button>
                                </li>

                                      <li>
                                    <Button href="javascript:void(0)">
                                        <span className="nav-text">Pool</span>
                                    </Button>
                                </li>


                                <li className="menu">
                                   <Button href="javascript:void(0)">
                                       <span className="nav-text">Level 2</span>
                                   </Button>

                                   <ul className="sub-menu">
                                      <li>
                                          <Button href="javascript:void(0)">
                                             <span className="nav-text">Level 3</span>
                                           </Button>
                                        </li>
                                        <li>
                                          <Button href="javascript:void(0)">
                                                <span className="nav-text">Level 3</span>
                                         </Button>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                   </ul>
               </li>


                <li className="ui_tooltip menu">
                    <Button className="void" href="javascript:void(0)">
                        <i className="zmdi zmdi-folder zmdi-hc-fw"/>
                        <span className="nav-text">Company Settings</span>
                    </Button>

                    <ul className="sub-menu">
                        <li>
                            <Button className="prepend-icon" href="#/app/components/alerts">
                                <span className="nav-text">Add/Remove</span>
                            </Button>
                        </li>
                        <li>
                            <Button className="prepend-icon" href="#/app/components/appbar">
                                <span className="nav-text">Billing</span>
                            </Button>
                        </li>
                        <li>
                            <Button className="prepend-icon" href="#/app/components/avatars">
                                <span className="nav-text">Company Listing</span>
                            </Button>
                        </li>
                    </ul>
                </li>
             
             <li className="menu no-arrow">
                    <Button href="#/app/widgets">
                        <i className="zmdi zmdi-widgets zmdi-hc-fw"/>
                        <span className="nav-text">Frieght Settings</span>
                    </Button>
                </li>


                <li className="menu no-arrow">
                    <Button href="#/app/widgets">
                        <i className="zmdi zmdi-widgets zmdi-hc-fw"/>
                        <span className="nav-text">Feedback</span>
                    </Button>
                </li>

                <li className="menu no-arrow">
                    <Button href="#/app/metrics">
                        <i className="zmdi zmdi-trending-up zmdi-hc-fw"/>
                        <span className="nav-text">Report</span>
                    </Button>
                </li>

               
            </ul>
        );
    }
}

export default withRouter(SideNavContent);


// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js